import { ApiError, apiFetch } from './client';

export interface TtsPreviewResult {
  speech: string;
  voice_pack?: string;
  tts: {
    audio_url: string | null;
    cache_hit?: boolean;
    error?: string;
  };
}

const PREVIEW_SAMPLES: Record<string, string> = {
  warm_mom: "Hi honey — don't forget your reminder.",
  calm_dad: "Hey kiddo, time for what we planned.",
  cheerful_friend: "Hey! Just a friendly nudge for you.",
  holiday: 'Ho ho — a little reminder from Grandpa.',
  dino: 'Roar! Friendly reminder time.',
  sparkle: 'Sparkle check — you have a reminder!',
  robot: 'Beep. Reminder sequence starting.',
  captain: 'Ahoy! Reminder on the horizon.',
};

/** Prefer /v1/tts/preview; fall back to /v1/tts when server is older. */
export async function previewVoicePack(
  voicePack: string,
  opts?: { lang?: string; sampleText?: string },
): Promise<TtsPreviewResult> {
  const lang = opts?.lang ?? 'en';
  const sampleText =
    opts?.sampleText?.trim() ||
    PREVIEW_SAMPLES[voicePack] ||
    'Hi — this is a Remindo voice preview.';

  try {
    return await apiFetch<TtsPreviewResult>('/v1/tts/preview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        voice_pack: voicePack,
        lang,
        sample_text: sampleText,
      }),
    });
  } catch (e) {
    if (!(e instanceof ApiError) || (e.status !== 404 && e.code !== 'request_failed')) {
      throw e;
    }
  }

  return apiFetch<TtsPreviewResult>('/v1/tts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      text: sampleText,
      voice_pack: voicePack,
      lang,
    }),
  });
}
